<div class="verify-password-page">
  <app-l-header></app-l-header>
  <!-- End Navbar -->
  <div class="wrapper wrapper-full-page">
    <div class="page-header login-page header-filter" filter-color="black" style="background-image: url('../../../assets/img/collegedreams.jpg'); background-size: cover; background-position: top center;">
      <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
      <div class="container end">
        <div class="row login-cards">
          <div class="col">
            <div class="d-flex align-items-start flex-column" style="height: 200px;">
              <div class="mt-5"></div>
              <div class="p-4 mt-5 pg1 text-center">
                Enter the code sent to your <br> email to verify your account
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-6 ml-auto mr-auto">
            <div class="card card-login card-hidden">
              <div class="card-header text-center">
                <h4 class="card-title">Verify Account</h4>
                <!--<div class="social-line">
                  Get password reset link
                </div>-->
              </div>
              <form novalidate  #verifyForm="ngForm" (ngSubmit)="verifyAccount()">
                <div class="card-body ">
                  <!--<span class="font-weight-bold red" >{{ errorMessage | titlecase }}</span>-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <div class="code-container">
                        <input oninput="this.value=this.value.slice(0,this.maxLength)"
                               type="number" maxlength="1" #first_code="ngModel"
                               class="code" placeholder="0"
                               [(ngModel)]="credentials.first_code"
                               [ngModelOptions]="{standalone: true}" required>
                        <input oninput="this.value=this.value.slice(0,this.maxLength)"
                               type="number" maxlength="1" #second_code="ngModel"
                               class="code" placeholder="0"
                               [(ngModel)]="credentials.second_code"
                               [ngModelOptions]="{standalone: true}" required>
                        <input oninput="this.value=this.value.slice(0,this.maxLength)"
                               type="number" maxlength="1" #third_code="ngModel"
                               class="code" placeholder="0"
                               [(ngModel)]="credentials.third_code"
                               [ngModelOptions]="{standalone: true}" required>
                        <!--<span>-</span>-->
                        <span class="line-1"></span>
                        <input oninput="this.value=this.value.slice(0,this.maxLength)"
                               type="number" maxlength="1" #fourth_code="ngModel"
                               class="code" placeholder="0"
                               [(ngModel)]="credentials.fourth_code"
                               [ngModelOptions]="{standalone: true}" required>
                        <input oninput="this.value=this.value.slice(0,this.maxLength)"
                               type="number" maxlength="1" #fifth_code="ngModel"
                               class="code" placeholder="0"
                               [(ngModel)]="credentials.fifth_code"
                               [ngModelOptions]="{standalone: true}" required>
                        <input oninput="this.value=this.value.slice(0,this.maxLength)"
                               type="number" maxlength="1" #sixth_code="ngModel"
                               class="code" placeholder="0"
                               [(ngModel)]="credentials.sixth_code"
                               [ngModelOptions]="{standalone: true}" required>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer justify-content-center">
                  <button type="submit" class="verify-button"
                          [disabled]="first_code.errors || second_code.errors || third_code.errors || fourth_code.errors || fifth_code.errors || sixth_code.errors">
                    <i class="fa fa-spinner fa-spin" *ngIf="loaders.loading"></i>
                    Verify Code
                  </button>
                </div>

                <div  style="font-size: 13px;">
                  <p class="text-center px-2 pb-3">
                    Don't Want to Verify Code?
                    <a href="javascript:void(0)" [routerLink]="['/login']" class="text-rose">
                      Login
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer">
        <app-l-footer></app-l-footer>
      </footer>
    </div>
  </div>
</div>
